import {
	selectErrorTimeslots,
	selectTimeslotsLoader,
	selectTimeslotsMap,
	TimeslotMapItem,
	UpdateTimeslotParams,
	useTimeslot,
} from 'entities/toolbar/timeslots';
import { LegacyRef, useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'shared/lib/store';

export const useTimeslots = () => {
	const ref: LegacyRef<HTMLDivElement> | undefined = useRef(null);
	const timeslots = useAppSelector(selectTimeslotsMap);
	const error = useAppSelector(selectErrorTimeslots);
	const isLoadingTimeslots = useAppSelector(selectTimeslotsLoader);
	const [scrollCoord, setScrollCoord] = useState(0);
	const [isComponentInit, setComponentInit] = useState(false);
	const { toTimeslot } = useTimeslot();
	const [enableSlotUpdatesBy, setEnableSlotUpdatesByOptions] =
	useState<UpdateTimeslotParams>({
		first: true,
			last: false,
		});


	useEffect(() => {
		setComponentInit(true);
	}, [isComponentInit]);

	const scroll = (scrollOptions: ScrollToOptions) => {
		ref.current && ref.current.scroll(scrollOptions);
	};

	const scrollToRight = () => {
		if (!enableSlotUpdatesBy.last) {
			const coord = scrollCoord + 135;
			setScrollCoord(coord);
			scroll({ left: coord });
		}
	};

	const scrollToLeft = () => {
		if (!enableSlotUpdatesBy.first) {
			const coord = scrollCoord - 135;
			setScrollCoord(coord);
			scroll({ left: coord });
		}
	};

	// NOTE: возможно пригодится
	// const updateTimeslots = (checkBy: string = '') => {
		// if (checkBy === 'last' && enableSlotUpdatesBy.last) {
		// 	scroll({ left: 0 });
		// 	setScrollCoord(0);
		// }
	// };

	const enableSlotUpdatesHandler = (options: UpdateTimeslotParams) => {
		setEnableSlotUpdatesByOptions(prev => {
			return { ...prev, ...options };
		});
	};

	const selectSlot = (slot: TimeslotMapItem) => {
		toTimeslot(slot.dt_start, { clear: true })
	};

	useEffect(() => {
		setScrollCoord(scrollCoord);
		scroll({ left: scrollCoord });
		// eslint-disable-next-line
	}, [timeslots]);

	// TODO НЕ работают слоты след дня, нужно придумать какую-то механику, в том числе на бэке, возможно использовать !isToday(timeslots[0]?.dt_start)

	useEffect(() => {
		if (!isLoadingTimeslots && ref.current) {
			const scrollContainer = ref.current;
			const handleScroll = () => {
				const scrollLeft = scrollContainer.scrollLeft;
				setScrollCoord(scrollLeft);
			};

			scrollContainer.addEventListener('scroll', handleScroll);
			return () =>
				scrollContainer.removeEventListener('scroll', handleScroll);
		}
	}, [isLoadingTimeslots]);

	return {
		timeslots,
		ref,
		isLoadingTimeslots,
		error,
		scrollToRight,
		scrollToLeft,
		enableSlotUpdatesHandler,
		selectSlot,
	};
};
